// frontend/src/site/builder/sections/ProvaSocialForm.jsx
import React from 'react';

function Label({ children }) {
  return <div className="text-sm font-medium text-gray-800">{children}</div>;
}
function Input({ value, onChange, placeholder = '' }) {
  return (
    <input
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      className="mt-2 w-full px-3 py-2 rounded-lg border border-gray-200"
    />
  );
}
function Textarea({ value, onChange, placeholder = '' }) {
  return (
    <textarea
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      className="mt-2 w-full px-3 py-2 rounded-lg border border-gray-200 min-h-[100px]"
    />
  );
}
function Select({ value, onChange, children }) {
  return (
    <select
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      className="mt-2 w-full px-3 py-2 rounded-lg border border-gray-200 bg-white"
    >
      {children}
    </select>
  );
}
function Switch({ checked, onChange, label }) {
  return (
    <button
      type="button"
      onClick={() => onChange?.(!checked)}
      className="flex items-center justify-between w-full"
    >
      <div className="text-sm text-gray-800">{label}</div>
      <div
        className={`w-12 h-7 rounded-full relative transition ${checked ? 'bg-black' : 'bg-gray-300'}`}
      >
        <span
          className={`absolute top-1 left-1 w-5 h-5 rounded-full bg-white transition ${checked ? 'translate-x-5' : ''}`}
        />
      </div>
    </button>
  );
}

export default function ProvaSocialForm({ value = {}, onChange }) {
  const v = value || {};
  const itens = Array.isArray(v.itens) ? v.itens : [];

  function patch(p) {
    onChange?.(p);
  }

  function setItem(i, p) {
    const next = [...itens];
    next[i] = { ...(next[i] || {}), ...(p || {}) };
    patch({ itens: next });
  }

  function addItem() {
    patch({
      itens: [...itens, { nome: '', cargo: '', texto: '', estrelas: 5 }],
    });
  }

  function removeItem(i) {
    patch({ itens: itens.filter((_, idx) => idx !== i) });
  }

  const enabled = v.enabled !== false;

  return (
    <div className="space-y-4">
      <Switch
        checked={enabled}
        onChange={(x) => patch({ enabled: x })}
        label="Ativar seção de depoimentos (Prova Social)"
      />

      {enabled ? (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div className="md:col-span-2">
              <Label>Título</Label>
              <Input
                value={v.titulo}
                onChange={(x) => patch({ titulo: x })}
                placeholder="Ex: O que dizem meus clientes"
              />
            </div>

            <div className="md:col-span-2">
              <Label>Subtítulo</Label>
              <Textarea
                value={v.subtitulo}
                onChange={(x) => patch({ subtitulo: x })}
                placeholder="Ex: Confira alguns depoimentos..."
              />
            </div>
          </div>

          <div className="rounded-xl border border-gray-200 p-4">
            <div className="flex items-center justify-between">
              <div className="font-medium text-gray-900">Depoimentos</div>
              <button
                type="button"
                onClick={addItem}
                className="px-3 py-2 rounded-lg bg-black text-white text-sm hover:opacity-90"
              >
                + Adicionar depoimento
              </button>
            </div>

            <div className="mt-4 space-y-3">
              {itens.length === 0 ? (
                <div className="text-sm text-gray-600">
                  Nenhum depoimento adicionado ainda.
                </div>
              ) : null}

              {itens.map((d, i) => (
                <div key={i} className="rounded-xl border border-gray-200 p-3">
                  <div className="flex items-center justify-between">
                    <div className="text-sm font-semibold text-gray-900">
                      Depoimento #{i + 1}
                    </div>
                    <button
                      type="button"
                      onClick={() => removeItem(i)}
                      className="px-3 py-2 rounded-lg border border-gray-200 hover:bg-gray-50 text-sm"
                    >
                      Remover
                    </button>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3">
                    <div>
                      <Label>Nome</Label>
                      <Input
                        value={d.nome}
                        onChange={(x) => setItem(i, { nome: x })}
                        placeholder="Ex: Fernanda Lima"
                      />
                    </div>
                    <div>
                      <Label>Cargo/Perfil</Label>
                      <Input
                        value={d.cargo}
                        onChange={(x) => setItem(i, { cargo: x })}
                        placeholder="Ex: Vendedora"
                      />
                    </div>
                    <div>
                      <Label>Estrelas</Label>
                      <Select
                        value={String(d.estrelas ?? 5)}
                        onChange={(x) => setItem(i, { estrelas: Number(x) })}
                      >
                        <option value="5">5</option>
                        <option value="4">4</option>
                        <option value="3">3</option>
                        <option value="2">2</option>
                        <option value="1">1</option>
                      </Select>
                    </div>

                    <div className="md:col-span-3">
                      <Label>Texto</Label>
                      <Textarea
                        value={d.texto}
                        onChange={(x) => setItem(i, { texto: x })}
                        placeholder="Ex: O corretor foi excepcional..."
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      ) : (
        <div className="text-sm text-gray-600">Seção desativada.</div>
      )}
    </div>
  );
}
